import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRoomContext } from '../../../RoomContext';

const styles = () =>
	({
		root :
		{
			width          : '100%',
			justifyContent : 'center',
			alignItems     : 'center',
			display        : 'flex',
			flexDirection  : 'column'
		},
		serviceName :
		{
			height          : '2.5rem',
			justifyContent  : 'center',
			alignItems      : 'center',
			display         : 'flex',
			flexDirection   : 'column',
			fontSize        : '1.2rem',
			padding         : '0.3rem 0',
			width           : '25%',
			backgroundColor : '#878686',
			color           : '#b3b3b3',
			borderRadius    : '0.7rem',
			boxShadow       : '2px 2px 4px inset #666'
		}
	});

const SerivceName = ({
	classes,
	user
}) =>
{
	const [ title, setTitle ] = useState('');

	useEffect(() =>
	{
		setTitle(user.serviceName);
	}, [ user ]);

	return (
		<div className={classes.root}>
			<div className={classes.serviceName}>
				{title}
			</div>
		</div>
	);
};

SerivceName.propTypes =
{
	classes : PropTypes.object.isRequired,
	user    : PropTypes.object.isRequired
};

const mapStateToProps = (state) =>
{
	return {
		user : state.me.user
	};
};

const mapDispatchToProps = () =>
{
	return {
	};
};

export default withRoomContext(connect(
	mapStateToProps,
	mapDispatchToProps,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.me.user === next.me.user

			);
		}
	}
)(withStyles(styles)(SerivceName)));
